// *NOTICE* This file is generated by the build, do not edit directly.
/* eslint-disable quotes, quote-props */
const footerLinks = {
  "items": [
    {
      "heading": "FooterLinks1",
      "id": "FooterLinks1",
      "links": [
        {
          "href": "https://mass.gov/topics/living",
          "text": "Living"
        },
        {
          "href": "https://mass.gov/topics/working",
          "text": "Working"
        },
        {
          "href": "https://mass.gov/topics/learning",
          "text": "Learning"
        },
        {
          "href": "https://mass.gov/topics/exploring-massachusetts",
          "text": "Visiting & Exploring"
        },
        {
          "href": "https://mass.gov/topics/your-government",
          "text": "Your Government"
        }
      ]
    },
    {
      "heading": "FooterLinks2",
      "id": "FooterLinks2",
      "links": [
        {
          "href": "https://mass.gov/site-policies",
          "text": "Site Policies"
        },
        {
          "href": "https://mass.gov/topics/public-records-requests",
          "text": "Public Records Requests"
        }
      ]
    }
  ]
};
export default { footerLinks };
